import type { TagType } from '~/consts/tags';

export type BulkActionMode = 'apply' | 'remove';
export type HotelBulkTagTarget = 'svc-offer' | 'bedbank';

export type BulkActionSuccessEntry = {
  offerId: string;
  changedTags: Array<string>;
  skippedTags: Array<string>;
  strippedTags?: Array<string>;
};

export type BulkActionResult = {
  mode: BulkActionMode;
  success: Array<BulkActionSuccessEntry>;
  unchanged: Array<string>;
  failures: Array<{ offerId: string; reason: string }>;
};

export type BulkTagField = 'campaigns' | 'holiday_types' | 'holidayTypes' | 'campaignTags';

export type BulkTagAdapterConfig = {
  title: string;
  labelSingular: string;
  labelPlural: string;
  fieldName: BulkTagField;
  helperText: string;
};

function getOfferIdsHelperText(supportsPropertyIds: boolean): string {
  return supportsPropertyIds ? 'Enter offer or property IDs.' : 'Enter offer IDs.';
}

export function getBulkTagAdapterConfig(
  tagType: TagType,
  verticalLabel: string,
  { supportsPropertyIds = false }: { supportsPropertyIds?: boolean } = {},
): BulkTagAdapterConfig {
  if (tagType === 'campaigns') {
    return {
      title: `Bulk apply campaign tags to ${verticalLabel} offers`,
      labelSingular: 'campaign tag',
      labelPlural: 'campaign tags',
      fieldName: 'campaigns',
      helperText: getOfferIdsHelperText(supportsPropertyIds),
    };
  }

  return {
    title: `Bulk apply holiday types to ${verticalLabel} offers`,
    labelSingular: 'holiday type',
    labelPlural: 'holiday types',
    fieldName: 'holiday_types',
    helperText: getOfferIdsHelperText(supportsPropertyIds),
  };
}
